import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";
import { CheckCircleOutline } from "@mui/icons-material";
import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";
import { formatAddress } from "../../settings/format";
import { User } from "../../models/airdrop-models";

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */
  return color;
}

function stringAvatar(name) {
  return {
    style: {
      width: 70,
      height: 70,
      margin: "auto",
      backgroundColor: stringToColor(name),
    },
    children: `${name.substr(0, 1).toUpperCase()}`,
  };
}

export default function Info({ data }) {
  const user = new User(data);

  return (
    <Grid item xs={12}>
      <Paper
        style={{
          padding: 20,
        }}
        variant="outlined"
      >
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item xs={1}>
            {user && <Avatar {...stringAvatar(user.email)} />}
          </Grid>
          <Grid item xs={5}>
            <Box pl={2}>
              <Typography variant="body2">ID: #{user && user.id}</Typography>
              <Typography variant="body2">
                Email: {user && user.email}
              </Typography>
              <Typography variant="body2">
                Address: {user && formatAddress(user.address)}
              </Typography>
              <Typography variant="body2">
                Join time:{" "}
                {user && moment(user.createdTime).format("YYYY-MM-DD")}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2">
              Status:{" "}
              {user && (
                <CheckCircleOutline
                  color={user.status === "ACTIVE" ? "primary" : "inherit"}
                  style={{ fontSize: "1.1em" }}
                />
              )}
            </Typography>
            <Typography variant="body2">
              Google authentication:
              {user && (
                <CheckCircleOutline
                  color={user.gaEnable ? "primary" : "inherit"}
                  style={{ fontSize: "1.1em" }}
                />
              )}
            </Typography>
            <Typography variant="body2">
              Parent ref ID: {user && user.referralId}
            </Typography>
            <Typography variant="body2">
              Ref ID: {user && user.linkRef}
            </Typography>
          </Grid>
          <Grid item xs={3}></Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
